const ApiPaths = {
    GET_ALL_LICENSES: '/licenses',
    CREATE_LICENSE: '/licenses/create',
    EDIT_LICENSE: '/licenses/edit',

    SESSIONS: '/scanning-sessions',
    GET_ALL_SESSIONS: '/scanning-sessions/list-all',
    CREATE_SESSIONS: '/scanning-sessions/create',
    SESSIONS_DOWNLOAD: '/scanning-sessions/download',
    SESSIONS_ANALYSE: '/scanning-sessions/analyse',
    SESSIONS_CREATE_FROM_ANALYSIS: '/scanning-sessions/create-from-analysis',
    SESSIONS_ITEMS_SEARCH: '/scanning-sessions/items/search',

    GROUP_EDITS: '/group-edits',
    
    AUTH_LOGIN: '/auth/login',
    AUTH_LOGOUT: '/auth/logout',
    AUTH_REFRESH_TOKEN: '/auth/refresh-token',
    AUTH_VERIFY_PASSWORD: '/auth/verify-password',
    AUTH_CHANGE_PASSWORD: '/auth/change-password',
    AUTH_FORGOT_PASSWORD: '/auth/forgot-password',
    AUTH_VALIDATE_RESET_TOKEN: '/auth/validate-reset-token',
    AUTH_RESET_PASSWORD: '/auth/reset-password',
    
    USERS: '/users',
    USERS_ME: '/users/me',
    CREATE_USER: '/users/create',
    EDIT_USER: '/users/edit',
    DELETE_USER: '/users/delete',
    RESEND_INVITE: '/users',
    
    CONTACT: '/contact',
    DEMO: '/demo',
    
  };
  
  export default ApiPaths;